import {
    needsLogin,
    PrimaryInfo, spotifyAuth, SpotifyReauthBanner, useSpotifySession,
} from "../util/util";
import React, {useEffect, useState} from "react";

import {MMStats} from "./mm-stats";

export const Stats = () => {

    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    const spotifySession = useSpotifySession();

    useEffect(() => {
        sessionStorage.setItem('route', 'stats');
        if (needsLogin()) {
            spotifyAuth();
        } else setLoggedIn(true);
    }, []);

    return (
        <>
            {loggedIn && (
                <>
                    <PrimaryInfo text={'Stats central.'}/>
                    <SpotifyReauthBanner session={spotifySession}/>
                    <MMStats />
                </>
            )}
        </>
    );
}

export const addCommaToNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}